import {
    StyledAlertText,
    StyledEditIconContainer,
    StyledImageContainer,
    StyledImagePlaceholderBox,
    StyledItemTextWrapper,
    StyledCardWrapper
} from './style'
import {useTranslation} from '@/translations/i18n'
import {
    OpsVettingCardContainer,
    OpsVettingImage
} from '@/features/ops-vetting/components/ops-vetting-atoms/OpsVettingAtoms'
import {AlertCircleIcon, Edit03Icon, Image01Icon} from '@/components/ui/icon/Icon'

interface ProPhotosServiceCardProps {
    title: string
    description: string
    coverImageUrl?: string | null
    onCardClick: () => void
}
export const ProPhotosServiceCard = ({title, description, coverImageUrl, onCardClick}: ProPhotosServiceCardProps) => {
    const {t} = useTranslation()

    return (
        <OpsVettingCardContainer
            direction="column"
            gap={2}
            fullWidth
            onClick={() => onCardClick()}
            style={{cursor: 'pointer'}}
        >
            <StyledCardWrapper>
                {coverImageUrl ? (
                    <StyledImageContainer>
                        <OpsVettingImage src={coverImageUrl} />
                        <StyledEditIconContainer className="show-on-hover">
                            <Edit03Icon />
                        </StyledEditIconContainer>
                    </StyledImageContainer>
                ) : (
                    <StyledImagePlaceholderBox>
                        <Image01Icon className="hide-on-hover" />
                        <Edit03Icon className="show-on-hover" />
                    </StyledImagePlaceholderBox>
                )}

                <StyledItemTextWrapper direction="column" gap={1}>
                    <h4>{title}</h4>
                    <p>{description}</p>

                    {!coverImageUrl && (
                        <StyledAlertText>
                            <AlertCircleIcon size={20} />
                            {t('vetting:reordering:missing_photo')}
                        </StyledAlertText>
                    )}
                </StyledItemTextWrapper>
            </StyledCardWrapper>
        </OpsVettingCardContainer>
    )
}
